import rollbar from '../rollbar';


export function makePath({ app, path }) {
  const route = app.view.main.router.currentRoute;
  return joinPath(route.path, path);
}


export function navigateTo({ app, path, options }) {
  const endPath = makePath({ app, path });

  app.view.main.router.navigate(endPath, options);
}


export function navigateBackTo({ app, path, options }) {
  const endPath     = makePath({ app, path });
  const { history } = app.view.main.router;
  const canUseBack  = !!history.filter(url => (url !== '/' && url !== app.view.main.router.currentRoute.url)).length;

  if (canUseBack)
    app.view.main.router.back(endPath, options);
  else {
    app.view.main.router.navigate(endPath, {
      ...options,
      clearPreviousHistory: true
    });
  }
}


function joinPath(base, path = '') {
  if (path === '')
    return base;
  if (path[0] === '/')
    return path;

  const first = path.split('/')[0];
  if (first === '.')
    return joinPath(base, path.slice(2));

  if (first === '..') {
    const parent = base.split('/').slice(0, -1).join('/');
    return joinPath(parent, path.slice(3));
  }

  return `${base}/${path}`;
}


// Handle an elusive bug in Framework7 when navigating
// quickly between pages and hitting back button.
// When this happens, navigation breaks and the only
// way out is to restart the app.
//
// Unfortunately this is hard to reproduce and may be
// an internal bug in Framework7. At least, fix navigation
// by reloading the page.
//
// https://github.com/broadly/broadly/issues/2976
window.onerror = function(message, source, lineno, colno, error) { // eslint-disable-line max-params
  if (message.includes('f7Page.route')) {
    rollbar.warn(error);
    window.location.reload();
    return true;
  } else if (message.includes('pageEl.parentNode')) {
    rollbar.warn(error);
    return true;
  } else
    return false;
};
